import React from 'react';
import { connect } from 'react-redux';
import {Container, Form, Input, Radio, Card, Button, Modal, Message} from "semantic-ui-react";
import {
    addNewServiceConfigNames,
    editReqInputGroup,
    createServiceConfigName,
    deleteSvcConfigName,
    delInputGroup,
    loadResourcesForDPServiceForm,
    selectServiceSet,
    selectBillingGroup,
    setDPServiceFormValues,
    updateProviderDropdownChanges,
    updateNotesField,
    updatePrimaryServiceConfigName,
    updateServiceDetailDropdownChanges,
    updateSvcConfigNamesArr, addNewReqInputsGroup, createNewNote, updateContactInfoField, copyServiceConfigName
} from "../actions/AddEditDPServiceActions";
import { validateBillingGroupForm } from "../actions/AddEditBillingGroupActions"
import Select from "react-select";
import lodash from "lodash/core";
import Table from "../../../common/components/Table/Table";
import * as Validation from "../../../common/utils/Validation";
import {fetchAllOrganizations} from "../../data-providers/actions/DataProviderActions";
import {closeAddEditModal} from "../actions/AddEditActions";
import BillingGroupForm from "../../add-edit/components/BillingGroupForm";
import DocumentEditor from "../../../common/partials/DocumentEditor";
import {fetchAllBillingGroups} from "../../billing-groups/actions/BillingGroupActions";

const serviceTypeOptions = [
    { label: "KYC", value: "kyc" },
    { label: "KYB", value: "kyb" },
];
const subDPTypeOptions = [
    { key: 1,label: "Business Verification", value: "bv" },
    { key: 2,label: "BV+", value: "bv+" },
    { key: 3,label: "ODO", value: "odo" },
    { key: 4,label: "KYB", value: "kyb" },
];
const integrationStatus = [
    {value: true, label: "Integrated"},
    {value: false, label: "Not Integrated"},
];
const inputFields = require("../../../common/resources/inputfields.json");

export class DPServicesForm extends React.Component {

    // create a ref for automatic smooth scrolling to the end of
    // the form in case of error/warning
    messagesEndRef = React.createRef();

    state = {
        copyService: {
            collection: {
                collectionid: null,
                created: "",
                description: null,
                modified: "",
                name: null
            },
            serviceID: null,
            serviceConfigName: "",
            veritasServiceID: null,
        },
        newServiceConfig: {
            collection: {
                collectionid: null,
                created: "",
                description: null,
                modified: "",
                name: null
            },
            serviceConfigName: "",
            veritasServiceID: null,
        },
        openCreateServiceConfigModal: false,
        openCreateBillingGroupModal: false,
        openCopyServiceModal: false,
        openCreateNotesModal: false,
        showReqInputsOptions: false,
        editingIG: false,
        addingIG: false,
        inputsArray: [],
        editInputsArray: [],
        editIndexOfInputGroup: null,
        countryForRequiredInput: {value: 'ZZZ', label: 'Please Select A Country'}
    }

    componentDidMount() {
        const {
            all_organizations,
            all_billing_groups,
            all_service_sets,
            all_service_config_names
        } = this.props;
        if (all_service_sets.length === 0 || all_service_config_names.length === 0) {
            this.props.getSupportingSelections();
        }
        if (all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
        if (all_billing_groups.length === 0) {
            this.props.getAllBillingGroups();
        }
        this.initialState = this.state;
    }

    componentWillUnmount() {
        this.setState(this.initialState)
    }

    scrollToBottom = () => {
        this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // eslint-disable-next-line no-unused-expressions
        (this.props.formErrorNotification || this.props.formWarningNotification)
            ? this.scrollToBottom() : null
    }

    handleInputFieldChanges = (e, { name, value, change_obj }) => {
        this.props.setDPServiceForm({ name, value, change_obj });
    };

    handleSCNInputFieldChanges = (e, { name, value, change_obj }) => {
        this.setState(prevState => ({
            newServiceConfig: {
                ...prevState.newServiceConfig,
                serviceConfigName: value
            }
        }));
    };

    handleSCNSelectServiceSet = (bg) => {
        // const {serviceObject} = this.props;
        this.setState(prevState => ({
            newServiceConfig: {
                ...prevState.newServiceConfig,
                collection: bg,
                // veritasServiceID: serviceObject.service_detail.service_id
            }
        }));
    }

    handleCopyServiceSelectServiceSet = (bg) => {
        const {serviceObject} = this.props;
        this.setState(prevState => ({
            copyService: {
                ...prevState.copyService,
                collection: bg,
                veritasServiceID: serviceObject.service_detail.service_id
            }
        }));
    }

    handleProviderDropdown = (bg, change_obj) => {
        this.props.selectProvider(bg, change_obj);
    }

    handleBillingGroupDropdown = (bg, change_obj) => {
        this.props.updateBillingGroup(bg, change_obj);
    }

    handleServiceDetailDropdown = (bg, change_obj) => {
        this.props.updateServiceDetail(bg, change_obj);
    }

    handleAddSvcConfigNames = (selectedServiceConfigNamesArr) => {
        selectedServiceConfigNamesArr.forEach(s => s.veritas_service_id = this.props.serviceObject.service_detail.service_id);
        this.props.updateSvcConfigNamesArr(selectedServiceConfigNamesArr);
    }

    handleSelectServiceSet = (bg) => {
        const {all_service_config_names} = this.props;
        this.props.updateSelectedServiceSet(bg, all_service_config_names);
    }

    handleRadioButtonClick = (e, {value}) => {
        this.props.updatePrimaryServiceConfig({value});
    }

    handleDeleteSvcConfigName = (e, {value}) => {
        this.props.deleteSvcConfigName({value});
    }

    handleAddNewServiceConfigName = () => {
        this.props.addNewServiceConfigNames();
    }

    handleCreateNewServiceConfigName = () => {
        this.setState({openCreateServiceConfigModal: true});
    }

    handleCopyServiceConfigName = (e, {value}) => {
        const {serviceObject, all_service_sets} = this.props;
        let collectionID = "";
        let svcName = "";
        let svcId = null;
        serviceObject.service_config_names.forEach(svc => {
            if (svc.serviceid === value) {
                collectionID = svc.collectionid;
                svcName = svc.name;
                svcId = svc.serviceid
            }
        })
        let serviceSet = {}
        all_service_sets.forEach(s => {
            if (s.collectionid === collectionID) {
                serviceSet = s;
            }
        })
        this.setState(prevState => ({
            openCopyServiceModal: true,
            copyService: {
                ...prevState.copyService,
                collection: serviceSet,
                veritasServiceID: serviceObject.service_detail.service_id,
                serviceConfigName: svcName,
                serviceID: svcId
            }
        }));
    }

    handleCreateNewBillingGroup = () => {
        this.setState({openCreateBillingGroupModal: true});
    }

    createSCNCLick = () => {
        this.props.createNewServiceInConfigTool(this.state.newServiceConfig);
        this.setState(this.initialState);
    }

    copyServiceCLick = () => {
        this.props.copyServiceName(this.state.copyService);
        Validation.clearMessages();
        this.props.closeModal("DP Service");
        this.setState(this.initialState);
    }

    createBGClick = () => {
        const {billingGroupObject} = this.props;
        const formSource = 'DPServicesForm';
        this.props.validateBillingGroupForm(billingGroupObject, formSource);
        this.setState(this.initialState)
    }

    handleAddNewInputGroup = (e) => {
        this.setState({
            showReqInputsOptions: true,
            addingIG: true,
        });
    }

    handleEditInputGroup = (e, index, country_iso) => {
        const {inputsArray} = this.props;
        const y = inputsArray[country_iso][index]

        e.preventDefault();
        this.setState({
            showReqInputsOptions: true,
            editingIG: true,
            editInputsArray: y,
            editIndexOfInputGroup: index,
            countryForRequiredInput: {value: country_iso, label: country_iso}
        });
    }

    handleSelectCountryForReqInputs = (c) => {
        const {inputsArray} = this.props;
        // by default we are only allowing to set the value
        // if the user tries to clear the selection, it will not go through.
        if (c !== null) {
            // check if the country exists in the DS, if not set the index to 0.
            // find the input group id so that we can set the values correctly.
            const lengthOfInputGroups =
                c.value in inputsArray
                ? Object.keys(inputsArray[c.value]).length
                : 0;
            this.setState({
                countryForRequiredInput: c,
                editIndexOfInputGroup: lengthOfInputGroups
            });
        }
    }

    handleSelectRequiredInputs = (req) => {
        const {serviceObject} = this.props;
        const {countryForRequiredInput} = this.state;
        // dummy-assigning the id here, will be replaced by uuid at api level
        req.forEach((r, idx) => {
            r.id = r.label_id
            r.recommended_input = false
            r.required_input = true
            r.service_id = serviceObject.service_detail.service_id
            r.element_index = idx
            r.input_group_id = this.state.editIndexOfInputGroup
            r.country_iso = countryForRequiredInput.value
        });

        this.setState({
            editInputsArray: req,
        });
    }

    handleAddReqInputs = (e) => {
        e.preventDefault();
        const {editInputsArray, editIndexOfInputGroup, countryForRequiredInput} = this.state;
        if (this.state.editingIG === true) {
            this.props.editInputGroup(editInputsArray, editIndexOfInputGroup, countryForRequiredInput.value);
        }
        if (this.state.addingIG === true) {
            this.props.addNewReqInputsGroup(editInputsArray, countryForRequiredInput.value);
        }
        this.setState({
            showReqInputsOptions: false,
            addingIG: false,
            editingIG: false,
            editInputsArray: [],
            countryForRequiredInput: {value: 'ZZZ', label: 'Please Select A Country'}
        });
    }

    handleDeleteInputGroup = (e, index, countryCode) => {
        e.preventDefault();
        this.props.delReqInputGroup(index, countryCode);
    }

    handleCancelReqInputs = (e) => {
        e.preventDefault();
        this.setState({
            showReqInputsOptions: false,
            editInputsArray: [],
            addingIG: false,
            editingIG: false,
        });
    }

    handleDPServiceDismiss = () => {
        Validation.clearMessages();
    }


    handleContactInfoFieldChanges = (e, { name, value, change_obj }) => {
        this.props.updateContact({ name, value, change_obj });
    }

    render() {
        const {
            serviceObject,
            all_organizations,
            all_billing_groups,
            available_service_config_names,
            all_service_sets,
            addSvcConfigNames,
            formattedIpKeys,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification,
        } = this.props;

        // create an array of value,label object to be used as an options dropdown using the countries
        // selected to have specific input keys.
        // default value is ZZ.
        let specificCountriesForIpKeys = [];
        serviceObject.associated_sources.forEach(source => {
            specificCountriesForIpKeys.push({value: source.country_iso, label: source.country_iso});
        });
        specificCountriesForIpKeys.push({value: 'ZZ', label: 'ZZ'})

        const {showReqInputsOptions, editInputsArray} = this.state;

        return(
            <div>
                <Container>
                    <Form>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Basic Description:
                                </h4>

                                <Form.Field
                                    onChange={this.handleInputFieldChanges}
                                    required
                                    control={Input}
                                    type="text"
                                    label="Service Name"
                                    placeholder="Service Name"
                                    value={serviceObject.service_detail.service_name === null ? "" : serviceObject.service_detail.service_name}
                                    name="service_name"
                                    change_obj = "service_detail"
                                />

                                <Form.Group widths={"equal"}>
                                    <Form.Field required>
                                        <label>Service Type</label>
                                        <Select
                                            onChange={this.handleServiceDetailDropdown}
                                            options={serviceTypeOptions}
                                            placeholder="Service Type"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="dp_type"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(serviceTypeOptions, {
                                                value: serviceObject.service_detail.dp_type
                                            })}
                                        />
                                    </Form.Field>

                                    {serviceObject.service_detail.dp_type === 'kyb'
                                        ? (
                                            <Form.Field required>
                                                <label>Sub-DP Type</label>
                                                <Select
                                                    onChange={this.handleServiceDetailDropdown}
                                                    options={subDPTypeOptions}
                                                    placeholder="Sub-DP Type"
                                                    name="sub_type"
                                                    isClearable={true}
                                                    value={lodash.find(subDPTypeOptions, {
                                                        value: serviceObject.service_detail.sub_type
                                                    })}
                                                />
                                            </Form.Field>
                                        )
                                        : null
                                    }

                                    <Form.Field required>
                                        <label>Integration Status</label>
                                        <Select
                                            onChange={this.handleServiceDetailDropdown}
                                            options={integrationStatus}
                                            placeholder="Status"
                                            isClearable={true}
                                            name="integration_status"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(integrationStatus, {
                                                value: serviceObject.service_detail.integration_status
                                            })}
                                        />
                                    </Form.Field>
                                </Form.Group>

                                <Form.Field required>
                                    <label>Provider Name</label>
                                    <Select
                                        onChange={this.handleProviderDropdown}
                                        options={all_organizations}
                                        placeholder="Data Provider"
                                        isSearchable={true}
                                        isClearable={true}
                                        change_obj = "associated_dp"
                                        name="associated_dp"
                                        getOptionLabel={option => option.provider_name}
                                        getOptionValue={option => option.provider_id}
                                        value={lodash.find(all_organizations, {
                                            provider_name: serviceObject.associated_dp.provider_name
                                        })}
                                    />
                                </Form.Field>

                                <Form.Field required>
                                    <label>Billing Group</label>
                                    <Select
                                        onChange={this.handleBillingGroupDropdown}
                                        options={all_billing_groups}
                                        placeholder="Billing Group"
                                        isSearchable={true}
                                        isClearable={true}
                                        change_obj = "billing_group"
                                        name="billing_group"
                                        getOptionLabel={option => option.billing_group_name}
                                        getOptionValue={option => option.id}
                                        value={lodash.find(all_billing_groups, {
                                            billing_group_name: serviceObject.billing_group.billing_group_name
                                        })}
                                    />
                                    <Button
                                        style={{marginTop: "10px"}}
                                        content={"Create New Billing Group"}
                                        onClick={this.handleCreateNewBillingGroup}
                                    />
                                </Form.Field>

                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Required Inputs:
                                </h4>

                                {serviceObject.input_keys.length === 0 ? (
                                    <p>No required input groups have been added.</p>
                                ) : (
                                    <Table
                                    >
                                        {formattedIpKeys
                                            ? (formattedIpKeys.map((inputGroup, idx) => {
                                                return (
                                                    <tr key={idx}>
                                                        <td>{inputGroup.country_iso}</td>
                                                        <td>{inputGroup.id}</td>
                                                        <td>{inputGroup.elements}</td>
                                                        <td>
                                                            <Button
                                                                size={"small"}
                                                                color={"blue"}
                                                                disabled={this.state.addingIG || this.state.editingIG}
                                                                content={"Edit Input Group"}
                                                                onClick={(e) =>
                                                                    this.handleEditInputGroup(e,
                                                                        inputGroup.id, inputGroup.country_iso)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Button
                                                                size={"small"}
                                                                color={"red"}
                                                                disabled={this.state.addingIG || this.state.editingIG}
                                                                onClick={(e) =>
                                                                    this.handleDeleteInputGroup(e,
                                                                        inputGroup.id, inputGroup.country_iso)}
                                                                content="Delete Input Group"
                                                            />
                                                        </td>

                                                    </tr>
                                                )}))
                                            : null
                                        }
                                    </Table>
                                )
                                }
                                {showReqInputsOptions
                                    ? (
                                        <div className="add-input-sidebar">
                                            <div className="form-item-container">
                                                <Select
                                                    isDisabled={this.state.editingIG}
                                                    isMulti={false}
                                                    // isClearable={true}
                                                    closeMenuOnSelect={true}
                                                    onChange={this.handleSelectCountryForReqInputs}
                                                    options={specificCountriesForIpKeys}
                                                    placeholder="Please Select A Country"
                                                    getOptionLabel={option => option.label}
                                                    getOptionValue={option => option.value}
                                                    value={lodash.find(specificCountriesForIpKeys, {
                                                        value: this.state.countryForRequiredInput.value
                                                    })}
                                                />
                                            </div>
                                            <div className="form-item-container">
                                                <Select
                                                    isMulti={true}
                                                    isClearable={true}
                                                    closeMenuOnSelect={true}
                                                    onChange={this.handleSelectRequiredInputs}
                                                    options={inputFields}
                                                    placeholder="Select Required Inputs"
                                                    getOptionLabel={option => option.label_name}
                                                    getOptionValue={option => option.label_id}
                                                    value={editInputsArray}
                                                />
                                            </div>

                                            <div className="inline-container">
                                                <Button
                                                    color={"blue"}
                                                    onClick={(e) => this.handleAddReqInputs(e)}
                                                    content="Done" />
                                                <Button
                                                    color={"red"}
                                                    onClick={(e) => this.handleCancelReqInputs(e)}
                                                    content="Cancel" />
                                            </div>
                                        </div>
                                    ) : null}

                                {showReqInputsOptions
                                    ? null
                                    : (<Button
                                        color={"blue"}
                                        content={"+ Required Inputs"}
                                        onClick={(e) => this.handleAddNewInputGroup(e)}
                                    />)
                                }

                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Associated Service Config Names:
                                </h4>

                                <Form.Group widths={"equal"}>
                                    <Form.Field>
                                        <label>Select Service Set</label>
                                        <Select
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            onChange={this.handleSelectServiceSet}
                                            options={all_service_sets}
                                            placeholder="Service Sets"
                                            isSearchable={true}
                                            isClearable={true}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.collectionid}
                                            // value={lodash.find(all_service_sets, {
                                            //     name: selectedServiceSet.name
                                            // })}
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>Select Service Config Names</label>
                                        <Select
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            isMulti
                                            onChange={this.handleAddSvcConfigNames}
                                            options={available_service_config_names}
                                            placeholder="Associated Service Config Names"
                                            isSearchable={true}
                                            isClearable={true}
                                            change_obj = "service_config_names"
                                            name = "service_config_names"
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.serviceid}
                                            value={addSvcConfigNames}
                                        />
                                        <Button
                                            style={{marginTop: "10px"}}
                                            content={"Add"}
                                            onClick={this.handleAddNewServiceConfigName}
                                        />
                                        <Button
                                            style={{marginTop: "10px"}}
                                            content={"Create New Service Config Name"}
                                            onClick={this.handleCreateNewServiceConfigName}
                                        />
                                    </Form.Field>

                                </Form.Group>

                                <Form.Field>
                                    <Table
                                        headers={[
                                            <Table.Header key="primary">Primary</Table.Header>,
                                            <Table.Header key="svc-name">Service Config Name (Service Set)</Table.Header>,
                                            <Table.Header key="remove" />
                                        ]}
                                    >
                                        {serviceObject.service_config_names.length && all_service_sets.length > 0
                                            ? (
                                                serviceObject.service_config_names.map((svc, idx) => {
                                                    return(
                                                        <tr key={idx} >
                                                            <td style={{padding: "0"}}>
                                                                <Radio
                                                                    name="radioGroup"
                                                                    value={svc.serviceid}
                                                                    checked={svc.is_primary}
                                                                    onChange={this.handleRadioButtonClick}
                                                                />
                                                            </td>
                                                            <td style={{padding: "0"}}>
                                                                {svc.name} ({lodash.find(all_service_sets, {
                                                                collectionid: svc.collectionid
                                                            }).name})
                                                            </td>
                                                            <td style={{padding: "0"}}>
                                                                <Button
                                                                    icon={"delete"}
                                                                    value={svc.serviceid}
                                                                    onClick={this.handleDeleteSvcConfigName} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            )
                                            : null}
                                    </Table>
                                </Form.Field>

                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Notes:
                                </h4>
                                {serviceObject.notes.length === 0 && !this.state.openCreateNotesModal ? (
                                    <div>
                                        <p>No Notes have been added.</p>
                                        <Button
                                            color={"blue"}
                                            content={"+ Notes"}
                                            onClick={() => this.setState({openCreateNotesModal: true})}
                                        />
                                    </div>
                                ) : (
                                    serviceObject.notes.map((note, idx) => {
                                        return(
                                            <div key={idx}>
                                                <h4>{note.type + " GDC Notes"}</h4>
                                                <DocumentEditor
                                                    initialValue={note.note}
                                                    value={note.note}
                                                    notes={true}
                                                    resourceType={note.type}
                                                    placeholderText={note.type + " Notes Regarding This Service."}
                                                />
                                                <br/>
                                            </div>
                                        )
                                    })
                                )
                                }
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Contact Info:
                                </h4>

                                {serviceObject.contact_info.length === 0 ? (
                                    <div>
                                        <p>No Notes have been added.</p>
                                        <Button
                                            color={"blue"}
                                            content={"+ Notes"}
                                            onClick={() => this.setState({openCreateNotesModal: true})}
                                        />
                                    </div>
                                ) : (
                                    serviceObject.contact_info.map((info, idx) => {
                                        return(
                                            <Form.Group widths="equal" key={idx}>
                                                <Form.Input
                                                    type="text"
                                                    label={info.type + " Contact Name"}
                                                    placeholder={info.type + " Contact Name"}
                                                    value={info.name === null ? "" : info.name}
                                                    name={info.type}
                                                    change_obj="name"
                                                    onChange={this.handleContactInfoFieldChanges}
                                                />
                                                <Form.Input
                                                    type="text"
                                                    label={info.type + " Contact Email"}
                                                    placeholder="john@email.com"
                                                    value={info.email === null ? "" : info.email}
                                                    name={info.type}
                                                    change_obj="email"
                                                    onChange={this.handleContactInfoFieldChanges}
                                                />
                                                <Form.Input
                                                    type="text"
                                                    label={info.type + " Contact Phone"}
                                                    placeholder="8005551234"
                                                    value={info.phone_number === null ? "" : info.phone_number}
                                                    name={info.type}
                                                    change_obj="phone_number"
                                                    onChange={this.handleContactInfoFieldChanges}
                                                />
                                            </Form.Group>
                                        )
                                    })
                                )}
                            </Card.Content>
                        </Card>

                        <div ref={this.messagesEndRef}/>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleDPServiceDismiss}
                                />
                            </div>
                        )
                        : null}
                </Container>


                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.state.openCreateServiceConfigModal}
                >
                    <Modal.Header>
                        {"Add New Service in Config Tool"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <Form>
                            <Card>
                                <Card.Content>
                                    <Form.Field>
                                        <label>Select Service Set</label>
                                        <Select
                                            onChange={this.handleSCNSelectServiceSet}
                                            options={all_service_sets}
                                            placeholder="Service Sets"
                                            isSearchable={true}
                                            isClearable={true}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.collectionid}
                                            value={this.state.newServiceConfig.collection}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        onChange={this.handleSCNInputFieldChanges}
                                        required
                                        control={Input}
                                        type="text"
                                        label="Service Config Name"
                                        placeholder="Service Config Name"
                                        value={this.state.newServiceConfig.serviceConfigName}
                                        name="service_config_name"
                                        change_obj = "service_config_name"
                                    />
                                </Card.Content>
                            </Card>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button type="button" color="red" inverted
                                onClick={() => this.setState({openCreateServiceConfigModal: false})}>
                            Cancel
                        </Button>
                        <Button color="green" inverted type="submit"
                                onClick={this.createSCNCLick}>
                            Create
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.state.openCreateBillingGroupModal}
                >
                    <Modal.Header>
                        {"Add New Billing Group"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <BillingGroupForm
                        formSource="DPServicesForm"
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button type="button" color="red" inverted
                                onClick={() => this.setState({openCreateBillingGroupModal: false})}>
                            Cancel
                        </Button>
                        <Button color="green" inverted type="submit"
                                onClick={this.createBGClick}>
                            Create
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.state.openCopyServiceModal}
                >
                    <Modal.Header>
                        {"Copy Service"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <Form>
                            <Card>
                                <Card.Content>
                                    <Form.Field>
                                        <label>Select Service Set</label>
                                        <Select
                                            onChange={this.handleCopyServiceSelectServiceSet}
                                            options={all_service_sets}
                                            placeholder="Service Sets"
                                            isSearchable={true}
                                            isClearable={true}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option.collectionid}
                                            value={this.state.copyService.collection}
                                        />
                                    </Form.Field>
                                    <Form.Field
                                        disabled
                                        control={Input}
                                        type="text"
                                        label="Service Config Name"
                                        value={this.state.copyService.serviceConfigName}
                                    />
                                </Card.Content>
                            </Card>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button type="button" color="red" inverted
                                onClick={() => this.setState({openCopyServiceModal: false})}>
                            Cancel
                        </Button>
                        <Button color="green" inverted type="submit"
                                onClick={this.copyServiceCLick}>
                            Copy
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    serviceObject: state.veritas.addEdit.addEditDPService.serviceObject,
    all_billing_groups: state.veritas.billingGroups.all_billing_groups,
    billingGroupObject: state.veritas.addEdit.addEditBillingGroup.billingGroupObject,
    available_service_config_names: state.veritas.addEdit.addEditDPService.available_service_config_names,
    all_service_sets: state.veritas.services.all_service_sets,
    all_service_config_names: state.veritas.services.all_service_config_names,
    addSvcConfigNames: state.veritas.addEdit.addEditDPService.addSvcConfigNames,
    dpInputFields: state.veritas.addEdit.addEditDPService.dpInputFields,
    statusOptions: state.veritas.addEdit.addEditDPService.statusOptions,
    selectedServiceSet: state.veritas.addEdit.addEditDPService.selectedServiceSet,
    inputsArray: state.veritas.addEdit.addEditDPService.inputsArray,
    formattedIpKeys: state.veritas.addEdit.addEditDPService.formattedIpKeys,
    // editModalOpenDPService: state.veritas.addEdit.addEditDPService.editModalOpenDPService,

    all_organizations: state.veritas.providers.all_organizations,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    getSupportingSelections: () => {dispatch(loadResourcesForDPServiceForm())},
    getAllOrganizations: () => {dispatch(fetchAllOrganizations())},
    getAllBillingGroups: () => {dispatch(fetchAllBillingGroups())},

    setDPServiceForm: ({ name, value, change_obj }) => {
        dispatch(setDPServiceFormValues({ name, value, change_obj }))
    },

    selectProvider: (bg, change_obj) => {dispatch(updateProviderDropdownChanges(bg, change_obj))},
    updateBillingGroup: (bg, change_obj) => {dispatch(selectBillingGroup(bg, change_obj))},
    validateBillingGroupForm: (billingGroupObj, formSource) => {dispatch(validateBillingGroupForm(billingGroupObj, formSource))},

    updatePrimaryServiceConfig: ({value}) => {dispatch(updatePrimaryServiceConfigName({value}))},
    updateSvcConfigNamesArr: (selectedServiceConfigNamesArr) => {dispatch(updateSvcConfigNamesArr(selectedServiceConfigNamesArr))},
    addNewServiceConfigNames: () => {dispatch(addNewServiceConfigNames())},
    deleteSvcConfigName: ({value}) => {dispatch(deleteSvcConfigName({value}))},
    createNewServiceInConfigTool: (scnObject) => {dispatch(createServiceConfigName(scnObject))},
    copyServiceName: (transferObject) => {dispatch(copyServiceConfigName(transferObject))},
    closeModal: (type) => {dispatch(closeAddEditModal(type))},

    updateServiceDetail: (bg, change_obj) => {dispatch(updateServiceDetailDropdownChanges(bg, change_obj))},

    updateSelectedServiceSet: (bg, all_service_config_names, change_obj) => {dispatch(selectServiceSet(bg,
        all_service_config_names, change_obj))},
    updateNotes: ({ name, value }) => {dispatch(updateNotesField({ name, value }))},
    updateContact: ({ name, value, change_obj }) => {dispatch(updateContactInfoField({ name, value, change_obj }))},

    editInputGroup: (editInputsArray, editIndexOfInputGroup, countryCode) => {
        dispatch(editReqInputGroup(editInputsArray, editIndexOfInputGroup, countryCode))},
    addNewReqInputsGroup: (editInputsArray, countryCode) => {dispatch(addNewReqInputsGroup(editInputsArray, countryCode))},
    delReqInputGroup: (deleteIndexOfInputGroup, countryCode) => {
        dispatch(delInputGroup(deleteIndexOfInputGroup, countryCode))},

    createNewNote: (notesObject) => {dispatch(createNewNote(notesObject))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DPServicesForm)
